import React from 'react';

export const ErrorNotFoundComponent = () => (
	<React.Fragment>
		Not Found
	</React.Fragment>
);
